// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__15EjQ","inner":"Footer_inner__1Vu2p","nextIcon":"Footer_nextIcon__20cDz","innerLeft":"Footer_innerLeft__1aiks"};